import React from "react";
import "./checkbox.scss";
export function Checkbox({ label, disabled, onChange, checked }) {
    return React.createElement(React.Fragment, null,
        React.createElement("label", { className: `ltg-checkbox` },
            !disabled ? (React.createElement("input", { onChange: ({ target }) => { onChange && onChange(target.checked); }, type: "checkbox", checked: checked })) : (""),
            React.createElement("div", { className: "ltg-checkbox-input" }),
            React.createElement("div", { className: "ltg-checkbox-label" }, label)));
}
